// Wait for the single, pinned CDN script in public/index.html before mounting custom elements.
// React 19 must see defined properties when it first creates controlled fields.
export function waitForPolaris(registry = window.customElements, timeoutMs = 15000) {
  const tags = ["s-page","s-section","s-badge","s-banner","s-button","s-icon","s-spinner","s-stack","s-divider","s-progress","s-empty-state","s-text-field","s-email-field","s-url-field","s-password-field","s-text-area","s-search-field","s-number-field","s-select","s-option","s-checkbox","s-modal","s-popover","s-date-picker","s-date-field","s-table","s-table-header-row","s-table-header","s-table-body","s-table-row","s-table-cell"];
  return new Promise((resolve, reject) => {
    const timeout = setTimeout(() => reject(new Error('Polaris components did not initialize.')), timeoutMs);
    Promise.all(tags.map(tag => registry.whenDefined(tag))).then(() => {
      clearTimeout(timeout);
      resolve();
    }, error => { clearTimeout(timeout); reject(error); });
  });
}
